/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Metadata_MergeInputs */

const en_event_group_options_metadata_merge = /** @type {(inputs: Event_Group_Options_Metadata_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata Merge`)
};

const fr_event_group_options_metadata_merge = /** @type {(inputs: Event_Group_Options_Metadata_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusion des métadonnées`)
};

const de_event_group_options_metadata_merge = /** @type {(inputs: Event_Group_Options_Metadata_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatenzusammenführung`)
};

const it_event_group_options_metadata_merge = /** @type {(inputs: Event_Group_Options_Metadata_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unione dei metadati`)
};

const ru_event_group_options_metadata_merge = /** @type {(inputs: Event_Group_Options_Metadata_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединение метаданных`)
};

const es_event_group_options_metadata_merge = /** @type {(inputs: Event_Group_Options_Metadata_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusión de metadatos`)
};

const zh_cn2_event_group_options_metadata_merge = /** @type {(inputs: Event_Group_Options_Metadata_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据合并`)
};

const ja_event_group_options_metadata_merge = /** @type {(inputs: Event_Group_Options_Metadata_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータのマージ`)
};

const hi_event_group_options_metadata_merge = /** @type {(inputs: Event_Group_Options_Metadata_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा मर्ज`)
};

const pt_pt2_event_group_options_metadata_merge = /** @type {(inputs: Event_Group_Options_Metadata_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusão de metadados`)
};

/**
* | output |
* | --- |
* | "Metadata Merge" |
*
* @param {Event_Group_Options_Metadata_MergeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_metadata_merge = /** @type {((inputs?: Event_Group_Options_Metadata_MergeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Metadata_MergeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_metadata_merge(inputs)
	if (locale === "de") return de_event_group_options_metadata_merge(inputs)
	if (locale === "it") return it_event_group_options_metadata_merge(inputs)
	if (locale === "ru") return ru_event_group_options_metadata_merge(inputs)
	if (locale === "es") return es_event_group_options_metadata_merge(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_metadata_merge(inputs)
	if (locale === "ja") return ja_event_group_options_metadata_merge(inputs)
	if (locale === "hi") return hi_event_group_options_metadata_merge(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_metadata_merge(inputs)
	return en_event_group_options_metadata_merge(inputs)
});